import Collections from "../features/collections/Collections";

const CollectionsPage = () => {
    return <Collections />;
};

export default CollectionsPage;
